import { useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { TranscriptionModal } from 'screens/BrandKits/components/SourceMaterialModal/TranscriptionModal'
import { AlignLeft } from 'blaze-ui/icons'

export const ShowTranscriptionButton = ({ content }: { content: string }) => {
  const { openModal } = useModals()

  return (
    <Button
      variant="tertiary"
      size="xs"
      onPress={() => openModal(TranscriptionModal, { content })}
      frontIcon={AlignLeft}
      aria-label="Show Transcribed Text"
    >
      Show Transcribed Text
    </Button>
  )
}
